import React from "react";
import css from "./RequestHelpSelect.css";
import PropTypes from "prop-types";
import Select from "common/StyledSelect";

const RequestHelpInterventionSelect = ({
  interventionRule,
  setInterventionRule,
  interventionRules
}) => {

  const toSelectOption = (rule) => {
    if (!rule) return null;
    return {
      label: rule.name,
      value: rule.id,
      description: rule.description
    }
  };

  return (
      <div className={css['input']}>
        <label htmlFor="interventionRule"><span>*</span> Type of help needed</label>
        <div className={css['input-select']}>
          <Select
              id="interventionRule"
              value={toSelectOption(interventionRule)}
              onChange={option => setInterventionRule(interventionRules.find(ruleItem => ruleItem.id === option.value))}
              options={interventionRules.map(toSelectOption)}
              placeholder={"Select the type of help needed"}
              maxMenuHeight={200}
              isDisabled={interventionRules.length === 0}
              ariaLabel={"Type of help needed"}
          />
        </div>
      </div>
  );

};

RequestHelpInterventionSelect.propTypes = {
  interventionRule: PropTypes.object,
  setInterventionRule: PropTypes.func.isRequired,
  interventionRules: PropTypes.array.isRequired
};

export default RequestHelpInterventionSelect;
